
<template>
  <router-view />
</template>

<script>
export default {
  name: "app-eventCategory"
};
</script>

<style lang="scss" scoped></style>
